import {AbstractPricingItemSummaryMapper} from "./abstract-pricing-item-summary.mapper";
import {PricingItem} from "../../../../domain/in/quote/pricing-item/pricing-item";
import {PricingItemSummary} from "../../../../domain/out/pricing-item-summary";
import {EnumPricingItemType} from "../../../../domain/in/quote/pricing-item/pricing-item-type";
import {
    DeviceConsumableWithSuppPricingItem
} from "../../../../domain/in/quote/pricing-item/device-consumable-with-supp-pricing-item";
import {ConsumablePricingItem} from "../../../../domain/in/quote/pricing-item/consumable-pricing-item";
import {PackPricingItem} from "../../../../domain/in/quote/pricing-item/pack-pricing-item";
import {MappingContext} from "./mapping-context";

export abstract class AbstractDeviceConsumableWithSuppMapper extends AbstractPricingItemSummaryMapper {

    protected async doMap(pricingItem: PricingItem, ctx: MappingContext): Promise<PricingItemSummary> {
        let pricingItemSummary = new PricingItemSummary();
        pricingItemSummary.codeElis = (pricingItem.pricingItemType == EnumPricingItemType.DEVICE ||
            pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE_WITH_SUPP ||
            pricingItem.pricingItemType == EnumPricingItemType.PACK) ? await ctx.resolveCodeElis((pricingItem as DeviceConsumableWithSuppPricingItem).device.codeElis) : '';
        pricingItemSummary.label = (pricingItem.pricingItemType == EnumPricingItemType.DEVICE ||
            pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE_WITH_SUPP ||
            pricingItem.pricingItemType == EnumPricingItemType.PACK) ? (pricingItem as DeviceConsumableWithSuppPricingItem).device.label : '';
        pricingItemSummary.quantity = (pricingItem.pricingItemType == EnumPricingItemType.DEVICE ||
            pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE_WITH_SUPP ||
            pricingItem.pricingItemType == EnumPricingItemType.PACK) ? pricingItem.userInputs.quantity : '';
        pricingItemSummary.appliedPrice = (pricingItem.pricingItemType == EnumPricingItemType.DEVICE ||
            pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE_WITH_SUPP ||
            pricingItem.pricingItemType == EnumPricingItemType.PACK) ? ctx.formatAmount((pricingItem as DeviceConsumableWithSuppPricingItem).device.appliedPrice) : '';
        pricingItemSummary.totalAppliedPrice = ctx.formatAmount(pricingItem.totalAppliedPrice);
        pricingItemSummary.frequency = await ctx.getFrequency(pricingItem);
        pricingItemSummary.consoCodeElis = await this.getConsoCodeElis(pricingItem, ctx);
        pricingItemSummary.consoLabel = this.getConsoLabel(pricingItem);
        pricingItemSummary.consoQuantity = this.getConsoQuantity(pricingItem);
        pricingItemSummary.consoAppliedPrice = this.getConsoAppliedPrice(pricingItem, ctx);
        pricingItemSummary.extraPrice = this.getExtraPrice(pricingItem, ctx);
        pricingItemSummary.franchiseConso = this.getFranchiseConso(pricingItem);
        return pricingItemSummary;
    }

    protected abstract getFranchiseConso(pricingItem: PricingItem): string | undefined;

    private getExtraPrice(pricingItem: PricingItem, ctx: MappingContext) {
        if (pricingItem.pricingItemType == EnumPricingItemType.CONSUMABLE ||
            pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE_WITH_SUPP) {
            return (pricingItem as ConsumablePricingItem).consumableExtraPrice ? ctx.formatAmount((pricingItem as ConsumablePricingItem).consumableExtraPrice) : '';
        } else {
            return '';
        }
    }

    private getConsoAppliedPrice(pricingItem: PricingItem, ctx: MappingContext) {
        if (pricingItem.pricingItemType == EnumPricingItemType.CONSUMABLE ||
            pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE_WITH_SUPP) {
            return (pricingItem as DeviceConsumableWithSuppPricingItem).consumable.appliedPrice ?
                ctx.formatAmount((pricingItem as DeviceConsumableWithSuppPricingItem).consumable.appliedPrice) :
                ctx.formatAmount((pricingItem as DeviceConsumableWithSuppPricingItem).additionalConsumablePrice);
        } else {
            return '';
        }
    }

    private getConsoQuantity(pricingItem: PricingItem) {
        if (pricingItem.pricingItemType == EnumPricingItemType.CONSUMABLE ||
            pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE_WITH_SUPP) {
            return pricingItem.userInputs.consumableQuantity;
        } else {
            return '';
        }
    }

    private getConsoLabel(pricingItem: PricingItem) {
        if (pricingItem.pricingItemType == EnumPricingItemType.PACK) {
            return (pricingItem as PackPricingItem).device.articleDetails['pack']["label"];
        } else if (pricingItem.pricingItemType == EnumPricingItemType.CONSUMABLE ||
            pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE_WITH_SUPP) {
            return (pricingItem as ConsumablePricingItem).consumable.label;
        } else {
            return '';
        }
    }

    private async getConsoCodeElis(pricingItem: PricingItem, ctx: MappingContext): Promise<string> {
        if (pricingItem.pricingItemType == EnumPricingItemType.PACK) {
            return ctx.resolveCodeElis((pricingItem as PackPricingItem).device.articleDetails['pack']["code"]);
        } else if (pricingItem.pricingItemType == EnumPricingItemType.CONSUMABLE ||
            pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE_WITH_SUPP) {
            return ctx.resolveCodeElis((pricingItem as ConsumablePricingItem).consumable.codeElis);
        } else {
            return '';
        }
    }

}
